<div class="flex flex-col gap-2 mb-4">
  <div class="loading w-full h-5" *ngIf="loading"></div>
  <div class="flex flex-row gap-2 justify-between" *ngIf="!loading">
    <ng-container
      [ngSwitch]="
        dynamicPricingUpsellInformation?.pricingAndAvailability?.price?.amount
          | fn: getPriceComparisonResult : null : dynamicPricingUpsellInformation?.dynamicPricingDetails?.price?.amount
      ">
      <ng-container *ngSwitchCase="PRICE_COMPARISON_RESULT.OVERPRICED">
        <div class="text-sm">
          You may be
          <span class="text-red-500">overpriced</span>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="PRICE_COMPARISON_RESULT.UNDERPRICED">
        <div class="text-sm">
          You may be
          <span class="text-green-500">underpriced</span>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="PRICE_COMPARISON_RESULT.NEUTRAL">
        <div class="text-sm">Your price looks good 👍</div>
      </ng-container>
    </ng-container>

    <div class="cursor-pointer text-sm text-night-darker strong" (click)="showBreakdown = !showBreakdown">
      <u>{{ showBreakdown ? 'Hide why' : 'Show why' }}</u>
    </div>
  </div>
  <div *ngIf="showBreakdown">
    <div class="border-t border-b border-smoke py-4 flex flex-col gap-2 w-full">
      <sbnb-dynamic-price-daily-breakdown
        [sidebarEmbedded]="true"
        [preview]="dynamicPricingUpsellInformation?.dynamicPricingDetails.price"
        [currentPrice]="dynamicPricingUpsellInformation?.pricingAndAvailability.price"
        [customCurrentPriceLabel]="
          dynamicPricingUpsellInformation?.multiple
            ? 'For example on ' + (dynamicPricingUpsellInformation?.date | date: 'MMM d') + ', your current price is:'
            : ''
        "></sbnb-dynamic-price-daily-breakdown>
      <ng-container *ngIf="!(isMobile$ | async); else mobileButtons">
        <sbnb-button
          *ngIf="dynamicPricingUpsellInformation?.outbound_dynamic_pricing_enabled"
          (click)="resetToDynamicPricing()"
          [loading]="resetting | async"
          size="mini"
          [fullWidth]="true"
          [label]="'Use dynamic pricing'"
          [loadingLabel]="'Resetting to dynamic pricing...'"
          [type]="'secondary'"></sbnb-button>

        <sbnb-button
          *ngIf="dynamicPricingUpsellInformation && !dynamicPricingUpsellInformation?.outbound_dynamic_pricing_enabled"
          size="mini"
          [fullWidth]="true"
          [type]="'secondary-grape'"
          icon="eye-grass"
          [label]="'Preview dynamic pricing'"
          (click)="previewDynamicPricing.emit()"></sbnb-button>
      </ng-container>
      <ng-template #mobileButtons>
        <sbnb-button
          *ngIf="dynamicPricingUpsellInformation?.outbound_dynamic_pricing_enabled"
          (click)="resetToDynamicPricing()"
          [loading]="resetting | async"
          size="mini"
          [fullWidth]="true"
          [label]="'Use dynamic pricing'"
          [loadingLabel]="'Resetting to dynamic pricing...'"
          [type]="'secondary'"></sbnb-button>

        <sbnb-button
          *ngIf="dynamicPricingUpsellInformation && !dynamicPricingUpsellInformation?.outbound_dynamic_pricing_enabled"
          size="mini"
          [fullWidth]="true"
          [type]="'secondary-grape'"
          icon="eye-grass"
          [label]="'Preview dynamic pricing'"
          (click)="presentMobileDPModal()"></sbnb-button>
      </ng-template>
    </div>
  </div>
</div>
